import { TicketModel } from '@/hooks/query';

import { smpService } from '@/features/single-match-parlay/services/smp.service';
import { TicketChoice } from '@/features/betslip/betslip-container/components/bet-ticket';

export const ConfirmBetSimpleChoice = ({
	tickets
}: {
	tickets: TicketModel[];
}) => {
	return tickets.map(ticket => (
		smpService.isSmpTicket(ticket) ? (
			<div 
				key={ticket.key} 
				className="ticket__choice"
			>
				{ticket.BettypeName}
			</div>
		) : (
			<TicketChoice 
				key={ticket.key} 
				ticket={ticket} 
			/>
		)
	));
};